<ng-container *transloco="let t">

  <div class="row">
    <div class="col-12 col-md-6 col-xl-4 text-center pb-2">
      <div ngbDropdown class="dropdown-small" container="body">
        <div class="dropdown" id="raceDropdown" ngbDropdownToggle>
          <span class="trim">
            {{
              race
                ? race.name
                : t("app.map.select.race")
            }}
          </span>
        </div>

        <div ngbDropdownMenu aria-labelledby="raceDropdown">
          <button *ngFor="let raceItem of eventItem?.racesList" ngbDropdownItem (click)="onRaceSelection(raceItem)">
            {{raceItem.name}}
            @if (race?.id === raceItem.id) {
              <i class="bi bi-check"></i>
            }
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (!!gpx || controlPointsList.length > 0 && (race?.raceSettings?.displayControlPoints ?? false)) {
    <div class="d-flex justify-content-between align-items-center py-2 title-border">
      <div class="d-flex flex-row align-items-center">
        <div class="pe-4">
          @if (race?.raceSettings?.enableGPXDownload) {
            <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--grey-neutral-800)'"
                            [text]="t('app.map.download.gpx.file')|uppercase" [borderColor]="'var(--teal-500)'"
                            (click)="downloadGPXFile()" [buttonHeight]="'36px'"></app-button-alt>
          }
        </div>
      </div>
    </div>

    <div class="py-3">
      @if (!!gpx) {
        <div>
          <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [increaseMapHeight]="true" [points]="waypointList"
                                    [gpx]="gpx" [defaultLanguage]="eventItem?.defaultLanguage"
                                    [languages]="languages"></app-leaflet-maps-wrapper>
        </div>
      }

      @if (!!gpx) {
        <h3 class="mt-4">{{t("race.details.profile")}}</h3>
        <app-race-profile [defaultLanguage]="eventItem?.defaultLanguage" [gpx]="gpx" [controlPointsList]="gpxWaypoints"
                          [elevationStats]="waypointsStats" [languages]="languages"></app-race-profile>
      }

      @if (controlPointsList.length > 0 && (race?.raceSettings?.displayControlPoints ?? false)) {
        <h3 class="mt-4">{{t("race.details.checkpoints.table")}}</h3>
        <div class="container container-no-padding-sm">
          <app-control-points-table [controlPointsList]="controlPointsList" [race]="race"
                                    [languages]="languages"></app-control-points-table>
        </div>
      }
    </div>

  } @else {
    <div class="py-3">
      <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [increaseMapHeight]="true" [points]="waypointList" [gpx]="gpx"
                                [defaultLanguage]="eventItem?.defaultLanguage"
                                [languages]="languages"></app-leaflet-maps-wrapper>
    </div>
  }
</ng-container>
